import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        user: '=',
        departments: '=',
        roles: '=',
        levels: '=',
        canManage: '='
    },
    template: `
        <div class="well color02" id="positions-section">
            <div class="heading01 type01">
                <h2>{{ 'user.Positions' | translate }}</h2>
                <a ng-if="vm.canManageUsers && vm.canManage" class="btn add" ng-click="vm.manageDrl()">{{ 'user.Add position' | translate }}</a>
            </div>
            <list-empty list="vm.user.drlsWithValue" show-add-message="true"></list-empty>
            <div class="tablewrapper" ng-if="vm.user.drlsWithValue.length">
                <table class="data01">
                    <thead>
                    <tr>
                        <th>{{ 'user.Department' | translate }}</th>
                        <th>{{ 'user.Role' | translate }}</th>
                        <th>{{ 'user.Level' | translate }}</th>
                        <!--<th class="todo">From</th>-->
                        <!--<th class="todo">To</th>-->
                        <th>&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr ng-repeat="drl in vm.user.drlsWithValue">
                        <td>{{ drl.departmentName }}</td>
                        <td>{{ drl.roleName }}</td>
                        <td>{{ drl.levelName }}</td>
                        <!--<td class="todo">11.11.2013</td>-->
                        <!--<td class="todo">-</td>-->
                        <td class="actions">
                            <a ng-if="vm.canManageUsers && vm.canManage && !drl.isExternalRelation" class="btn edit" ng-click="vm.manageDrl(drl.id)">{{ 'general.Edit' | translate }}</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    `
})
export default class {
    constructor (ModalService, UserResource, CourseResource, PrivilegeService) {
        this.ModalService = ModalService;
        this.UserResource = UserResource;
        this.CourseResource = CourseResource;
        this.canManageUsers = PrivilegeService.canManageUsers();
    }

    $onInit () {
        this.userDrlCourses = [];
        this.loadPlanningGroupCourses();
    }

    loadPlanningGroupCourses () {
        this.CourseResource.query({ userId: this.user.id, planningGroupCourses: true, expand: 'planningGroups.planningGroupTargets,courseTargets' }).$promise
            .then(userDrlCourses => {
                this.userDrlCourses = userDrlCourses;
            });
    }

    manageDrl (id) {
        const { departments, roles, levels, user, userDrlCourses } = this;
        this.reloadUser(); // to avoid cached error values

        return this.ModalService.open({
            template: `
                <modals-user-employee-drl
                    on-close="vm.$uibModalInstance.dismiss()"
                    on-update="vm.update()"
                    departments="vm.departments"
                    roles="vm.roles"
                    levels="vm.levels"
                    user="vm.user"
                    drl-id="vm.drlId"
                    user-drl-courses="vm.userDrlCourses"
                    class="wrapper"
                />
                `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.departments = departments;
                this.roles = roles;
                this.levels = levels;
                this.user = user;
                this.drlId = id;
                this.userDrlCourses = userDrlCourses;
                this.update = this.$uibModalInstance.close;
            }
        })
        .then(() => {
            this.loadPlanningGroupCourses();
            this.reloadUser();
        });
    }

    reloadUser () {
        this.UserResource.get({ id: this.user.id, expand: 'drlsWithValue,inactivityPeriods' })
            .$promise.then((reloadedUser) => {
                this.user = reloadedUser;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/employee/detail/drlList/index.js